(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('factory', {
            parent: 'company_admin',
            url: '/factory?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.factory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/factory/factories.html',
                    controller: 'FactoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('factory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('factory-detail', {
            parent: 'company_admin',
            url: '/factory/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.factory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/factory/factory-detail.html',
                    controller: 'FactoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('factory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Factory', function($stateParams, Factory) {
                    return Factory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'factory',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('factory-detail.edit', {
            parent: 'factory-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-dialog.html',
                    controller: 'FactoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Factory', function(Factory) {
                            return Factory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('factory.new', {
            parent: 'factory',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-dialog.html',
                    controller: 'FactoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('factory', null, { reload: 'factory' });
                }, function() {
                    $state.go('factory');
                });
            }]
        })
        .state('factory.edit', {
            parent: 'factory',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-dialog.html',
                    controller: 'FactoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Factory', function(Factory) {
                            return Factory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('factory', null, { reload: 'factory' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('factory.delete', {
            parent: 'factory',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/factory/factory-delete-dialog.html',
                    controller: 'FactoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Factory', function(Factory) {
                            return Factory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('factory', null, { reload: 'factory' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
